import erlClient from '.';

export interface VesselEntry {
  data: Record<string, { current_value: string | null; previous_value?: string | null }>;
  last_update: string;
}

export type VesselSchedule = Record<string, VesselEntry[]>;

export const getVesselScheduleEnd = async (): Promise<VesselSchedule> => {
  const res = await erlClient.get('/instructions/api/v1/vessels');
  const { data } = res || {};
  return data;
};
